// extracted by mini-css-extract-plugin
export var artist = "Album-module--artist--fedd4";
export var cover = "Album-module--cover--6030e";
export var el = "Album-module--el--9866a";
export var elSmall = "Album-module--el--small--5b25f";
export var link = "Album-module--link--c9cd3";
export var title = "Album-module--title--0b3d1";